import { useMediaQuery } from "react-responsive";

export const useIsMobile = () => {
  return !useMediaQuery({
    query: "(min-width: 769px)",
  });
};
